import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale, Filler } from 'chart.js';
import { format, parseISO, isValid } from 'date-fns';
// Pont jetons CSS → canvas : la courbe lit la charte au lieu de figer une couleur.
import { jetons, alpha, optionsBase } from '../../../../components/ndoe/chartTheme';

// Filler est indispensable : sans lui, `fill: true` est ignoré en silence et
// l'aire sous la courbe ne se peint jamais.
ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale, Filler);

const DepensePeriode = ({ data }) => {

  const formatDate = (dateString) => {
    const date = parseISO(dateString);
    return isValid(date) ? format(date, 'dd MMM yyyy') : 'Date invalide'; // Format souhaité : 07 May 2024
  };

  const labels = data ? data.map(item => formatDate(item.date)) : [];
  const values = data ? data.map(item => item.total_periode) : [];

  // Le bleu royal de la charte, pas le vert d'eau par défaut de Chart.js
  // (rgba(75,192,192,1)) : cette teinte n'existait nulle part ailleurs dans
  // l'app. Bleu et non doré, pour que les dépenses ne se confondent pas avec
  // les courbes de chiffre d'affaires, dorées partout ailleurs ; et non rouge,
  // car une dépense est une opération normale, pas une perte à signaler.
  // Appel DANS le composant : au chargement du module le CSS n'est pas garanti
  // appliqué et le pont retomberait sur ses valeurs de repli sans le dire.
  const t = jetons();

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Total des Dépenses',
        data: values,
        fill: true,
        borderColor: t.royal,
        backgroundColor: alpha(t.royal, 0.1),
        borderWidth: 2,
        pointRadius: 2,
        pointHoverRadius: 5,
        tension: 0.35,
      },
    ],
  };

  // optionsBase apporte la grille, les axes, l'info-bulle aux couleurs de la
  // charte et une animation sobre coupée si l'utilisateur a demandé moins de
  // mouvement au niveau du système. La légende reste affichée : elle porte le
  // seul libellé de l'écran, « Total des Dépenses ».
  const options = optionsBase();

  return (
    // Hauteur explicite : optionsBase pose maintainAspectRatio: false, et sans
    // conteneur dimensionné le canvas s'effondrerait à zéro pixel.
    <div style={{ height: 280 }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default DepensePeriode;
